import { BellIcon, XIcon } from '@heroicons/react/outline'
import { useEffect, useState } from 'react'

function SuccessNotice({ children, onRemove }) {
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        setIsVisible(true)
        const timer = setTimeout(() => {
            setIsVisible(false)
            onRemove()
        }, 2000)
        return () => clearTimeout(timer)
    }, [])

    return (
        <div
            className={`rounded-lg shadow-lg bg-olm-green text-white z-50 fixed w-96 top-10 transition-all duration-300 transform ${
                isVisible ? 'right-2' : '-right-full'
            } p-4`}>
            <div className="flex items-center">
                <div className="flex-shrink-0">
                    <BellIcon className="h-5 w-5" />
                </div>
                <div className="ml-4">
                    <p className="text-sm font-semibold">{children}</p>
                </div>
                <div className="ml-auto pl-2">
                    <div className="-mx-2 -my-2">
                        <button
                            onClick={() => {
                                setIsVisible(false)
                                onRemove()
                            }}
                            type="button"
                            className="bg-transparent text-white font-semibold flex items-center border border-transparent rounded-lg p-2 text-center cursor-pointer hover:bg-olh hover:border-olh hover:text-white focus:outline-none focus:ring-1 focus:ring-olh focus:border-olh sm:text-sm">
                            <XIcon className="h-5 w-5" aria-hidden="true" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SuccessNotice
